import type { AcceptqueueResponse } from '../../models/job.model';
import { extractStatusMessage } from './adapter.utils';

/**
 * Builds the `multipart/form-data` payload for
 * `POST /process-server/{serverId}/jobs/acceptqueue`.
 *
 * @remarks
 * Laravel expects PHP-style array keys: each job number is appended as a
 * separate `job_number[]` field (e.g. `job_number[]=257759`).
 * Passing the returned `FormData` to Angular's `HttpClient` automatically
 * sets `Content-Type: multipart/form-data` with the correct boundary.
 *
 * @param jobNums - Array of job numbers to accept.
 */
export function toPayload(jobNums: number[]): FormData {
  const fd = new FormData();
  jobNums.forEach(n => fd.append('job_number[]', String(n)));
  return fd;
}

/**
 * Maps the `POST /process-server/{serverId}/jobs/acceptqueue` response.
 *
 * @remarks
 * Live API returns `{ "status": "success", "message": "Jobs Accepted are: 257759. Please Check Open Jobs List" }`.
 *
 * @param raw - Untyped API response.
 */
export function acceptqueueToModel(raw: unknown): AcceptqueueResponse {
  return extractStatusMessage(raw);
}
